import { render, staticRenderFns } from "./DataFastPayPublic.vue?vue&type=template&id=2e30b9d0&scoped=true"
import script from "./DataFastPayPublic.vue?vue&type=script&lang=js"
export * from "./DataFastPayPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e30b9d0",
  null
  
)

export default component.exports